import { bool, shape, string } from "prop-types"

const AttendeeDetail = ({ attendee, hideSelectionType = false }) => {
  return (
    <span className={`${attendee.isCanceled ? "t-strike c-neutral-500" : ""}`}>
      {attendee.name}
      {attendee.isCanceled && " (canceled)"}
      {!hideSelectionType && (
        <span className="ml-1 font-size-4 c-neutral-400">{attendee.attendeeTypeName}</span>
      )}
    </span>
  )
}

AttendeeDetail.propTypes = {
  attendee: shape({
    isCanceled: bool,
    name: string,
    attendeeTypeName: string
  }).isRequired,
  hideSelectionType: bool
}

export default AttendeeDetail
